module.exports = __webpack_public_path__ + "img/work3-1.4eba8a5f.png";